import { render } from "./DailyContent.vue?vue&type=template&id=4cbf66ab&scoped=true"
import script from "./DailyContent.vue?vue&type=script&lang=js"
export * from "./DailyContent.vue?vue&type=script&lang=js"

import "./DailyContent.vue?vue&type=style&index=0&id=4cbf66ab&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src310475096/src/AstopiaAdminPanel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cbf66ab"]])

export default __exports__